<template>
    <div>
        <!-- <n-card style="width: 100%; height: 88vh; border: 1px;position:fixed;"> -->
        <iframe src="https://wx1.chatmee.cn/invite/F_RAnV6vETTF5JMRY3" style="width: 100%; height: 88vh; border: 0.01px;"></iframe>
        <!-- </n-card> -->
    </div>
</template>

<script>

</script>

<style>
</style>